import React from 'react';
import { motion } from 'framer-motion';
import { Bot, BellRing } from 'lucide-react';
import SpotlightCard from './SpotlightCard';
import { Translations } from '../types';

interface WhatsNewProps {
  t: Translations;
}

const icons = [Bot, BellRing];

export const WhatsNew: React.FC<WhatsNewProps> = ({ t }) => {
  return (
    <section className="whats-new" aria-labelledby="whats-new-heading" id="whats-new">
      <div className="container">
        <motion.div
          className="whats-new-header"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <p className="whats-new-eyebrow">{t.whatsNew.subtitle}</p>
          <h2 id="whats-new-heading" className="whats-new-title">
            {t.whatsNew.title}
          </h2>
        </motion.div>

        <div className="whats-new-grid" role="list" aria-label={t.whatsNew.title}>
          {t.whatsNew.items.map((item, index) => {
            const Icon = icons[index % icons.length];
            return (
              <motion.article
                key={item.title}
                role="listitem"
                className="whats-new-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <SpotlightCard className="whats-new-card-inner" spotlightColor="rgba(0, 255, 157, 0.12)">
                  <div className="whats-new-card-top">
                    <div className="whats-new-tag">{item.tag}</div>
                    <div className="whats-new-seq" aria-hidden="true">
                      <span className="whats-new-seq-dot" />
                      <span className="whats-new-seq-label">{`0${index + 1}`}</span>
                    </div>
                  </div>
                  <div className="whats-new-card-body">
                    <div className="whats-new-icon" aria-hidden="true">
                      <Icon size={22} />
                    </div>
                    <div>
                      <h3 className="whats-new-item-title">{item.title}</h3>
                      <p className="whats-new-description">{item.description}</p>
                    </div>
                  </div>
                </SpotlightCard>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
